module.exports = __webpack_public_path__ + "static/img/osde-2.0269237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/osde-2.jpg
// module id = 9ltq
// module chunks = 1